import useSite from "@casino/legacy/client/hooks/useSite";
import internationalCallingCodes from "@casino/legacyUi/form/FormSelect/InternationalCallingCodes";
import { useMemo } from "react";
import getInternationalCallingCodes from "../helpers/getInternationalCallingCodes";

const getCountryCallingCode = (countryCode: string) =>
  internationalCallingCodes?.[countryCode]?.code.toString();

const formatPhoneCallingCode = ({
  callingCode,
  country,
  phone,
}: {
  callingCode: string;
  country: string;
  phone: string;
}) => {
  const code = getCountryCallingCode(country) || "";
  if (callingCode && code) {
    return { phone: phone?.replace(`+${code}`, ""), code };
  }
  return { phone, code: callingCode };
};

const withoutCountries = (
  options: SelectOption[],
  excludedCountries?: string[],
) =>
  excludedCountries
    ? options.filter(
        (option) => !excludedCountries.includes(option.value.toString()),
      )
    : options;

const useCallingCodes = (excludedCountries?: string[]) => {
  const { site } = useSite();

  const primaryOptions: SelectOption[] = useMemo(
    () =>
      withoutCountries(
        getInternationalCallingCodes(true, site),
        excludedCountries,
      ),
    [site, excludedCountries],
  );
  const secondaryOptions: SelectOption[] = useMemo(
    () =>
      withoutCountries(
        getInternationalCallingCodes(false, site),
        excludedCountries,
      ),
    [site, excludedCountries],
  );

  return {
    primaryOptions,
    secondaryOptions,
    getCountryCallingCode,
    formatPhoneCallingCode,
  };
};

export default useCallingCodes;
